export const brandMap = {
  whirl: 'whirlpool',
  amana: 'amana',
  mytag: 'maytag',
  khaid: 'kitchenaid',
  jnair: 'jennair',
  gladi: 'gladiator',
} as const;

export type BrandCode = keyof typeof brandMap;
